<template>
  <v-form v-model="valid">
    <v-container fluid class="mt-4">
      <v-row dense>
        <v-col cols="12" sm="6" md="5">
          <v-text-field label="Name" v-model="spirit.name" :rules="[fieldRules.required,fieldRules.maxLength(50)]" :counter="50" outlined dense/>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <v-text-field label="SKU" v-model="spirit.sku" :rules="[fieldRules.maxLength(50)]" :counter="10" outlined dense/>
        </v-col>
        <v-col cols="2" lg="1">
          <v-checkbox label="Active" v-model="spirit.active" dense class="mt-1"/>
        </v-col>
      </v-row>

      <v-row v-if="values && connectedToAccounting">
        <v-col cols="12" sm="6" md="4">
          <account-picker v-model="spirit.inventoryAccountRef" label="Inventory asset account"
                          :accounts="accounts" :addTypes="['OtherCurrentAsset']"
                          hint="The inventory account used to track the value of this spirit"/>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: 'SpiritsEditInfo',
  props: {
    spirit: {type:Object, required:true},
    accounts: {type:Array, required:true},
    values: {type:Boolean, required:true}
  },
  data() {
    return {
      valid: true
    }
  },
  computed: {
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    }
  }
}
</script>